// Force US locale for the entire application
export const setupUSLocale = () => {
  // Set the document language
  if (document.documentElement) {
    document.documentElement.lang = 'en-US';
  }

  // Override Intl.DateTimeFormat to use US format by default
  const originalDateTimeFormat = Intl.DateTimeFormat;
  Intl.DateTimeFormat = function(locale, options) {
    return new originalDateTimeFormat('en-US', options);
  };

  // Apply US locale styling to existing and future date inputs
  const applyUSDateFormat = () => {
    const dateInputs = document.querySelectorAll('input[type="date"], input[type="datetime-local"]');
    dateInputs.forEach(input => {
      input.lang = 'en-US';
      input.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
      input.style.direction = 'ltr';
    });
  };

  // Apply formatting now and on DOM changes
  applyUSDateFormat();
  
  // Set up observer to catch dynamically added date inputs
  const observer = new MutationObserver(() => {
    applyUSDateFormat();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

// Call this when the app starts
if (typeof window !== 'undefined') {
  setupUSLocale();
}